export default __webpack_public_path__ + "static/media/chatBlue.802d5f2f.svg";